import { SelectOption } from "../../../../types/select";
import { convertToTitleCase } from "../convertToTitleCase";

type Options = {
  isTitleCaseLabel?: boolean;
};

export const mapValueToSelectOption = <TValue extends string>(
  input: TValue,
  options?: Options,
): SelectOption<TValue> => {
  const { isTitleCaseLabel = false } = options || {};

  return {
    label: isTitleCaseLabel ? convertToTitleCase(input) : input,
    value: input,
  };
};
